module.exports={
  "techOrder": [
    "html5",
    "Chromecast"
  ],
  "hlsjs": {
    "hlsConfig": {
      "abrBandWidthFactor": 0.9,
      "abrBandWidthUpFactor": 0.8,
      "debug": false,
      "fragLoadingMaxRetry": 4,
      "fragLoadingRetryDelay": 100,
      "levelLoadingMaxRetry": 4,
      "levelLoadingRetryDelay": 100,
      "manifestLoadingMaxRetry": 1,
      "manifestLoadingRetryDelay": 100,
      "autoStartLoad": false,
      "liveSyncDurationCount": 2,
      "maxBufferLength": 30,
      "maxMaxBufferLength": 60,
      "maxBufferSize": 12000000,
      "backBufferLength": 30,
      "enableWebVTT": false,
      "capLevelToPlayerSize": true
    }
  },
  "html5": {
    "nativeTextTracks": false
  },
  "ad_code_prefix": "",
  "ad_midroll_max_duration": 90000,
  "ad_midroll_min_duration": 1000,
  "ad_tag": "",
  "ad_tag_gpt_midroll": false,
  "ad_tag_gpt_preroll": false,
  "ad_tag_midroll": "",
  "ad_companion": true,
  "ads_live_per_block": 3,
  "ads_live_playback_delay": 4,
  "ads_max_retries_midroll": 3,
  "ads_max_retries_preroll": 1,
  "adAlmostFinishedThreshold": 4,
  "auto_setup": true,
  "autoplay": true,
  "aspectRatio": "16:9",
  "comscore_ns_site": "bloomberg-stream-test",
  "comscore_page_level_tags": {},
  "controls": true,
  "disable_companion_ads": false,
  "disable_overlay_companion_ads": false,
  "forcePosterMobile": true,
  "live": false,
  "log_debug": true,
  "maxRetries": 3,
  "module_ad_player": "enabled",
  "persistTextTrackSettings": true,
  "poster_as_slate": false,
  "preroll_ads_per_block": 1,
  "preroll_ads_playback_delay": 0,
  "start_muted": false,
  "start_time": 0,
  "ui_autohide_timeout": 2000,
  "use_activity_out": true,
  "use_captions": true,
  "use_clickable_ads": true,
  "use_comscore": true,
  "use_js_ads": true,
  "use_parsely": true,
  "use_persist_listeners": true,
  "use_playback_outro": true,
  "use_poster_slate": true,
  "use_recover_hls": true,
  "use_smooth_scrub": true,
  "use_stream_watchdog": true,
  "use_title_bar": true,
  "use_google_tag_manager": false,
  "use_youbora": true,
  "use_resize_player": true,
  "useAutoplayBrowsersPlugin": true,
  "useVideoMidrollPlugin": true,
  "useChromeCastPlugin": false,
  "useFoundationLayout": false,
  "usePhoenixTheme": false,
  "google_tag_manager_data_layer_id": "dataLayer",
  "enableAudioBars": false,
  "useRegUIPopUpPlugin": false,
  "enableDai": true,
  "useIndexExchange": true,
  "useViewabilityPlugin": true,
  "useViewableAdImpressionPlugin": true,
  "site": null,
  "hidePlayerControls": false,
  "useNonInteractiveProgressBar": false,
  "useCustomBufferingAnimation": false,
  "customBufferingAnimationAsset": "",
  "enableClosedCaptionsApi": false,
  "hideNativePlayerControls": false,
  "enablePlayPauseOverlay": false,
  "useTranscriptPlugin": false,
  "useTheaterModePlugin": false,
  "usePlayerToutPlugin": false,
  "useFullscreenControlPlugin": true,
  "useContentOverlayPlugin": false,
  "useTestDaiStream": false,
  "textTrackSettings": {
    "pauseOnOpen": false
  },
  "playbackRates": [0.5, 0.75, 1, 1.25, 1.5, 2],
  "controlBar": {
    "children": [
      "playToggle",
      "volumePanel",
      "currentTimeDisplay",
      "timeDivider",
      "durationDisplay",
      "progressControl",
      "bloombergLiveDisplay",
      "remainingTimeDisplay",
      "customControlSpacer",
      "playbackRateMenuButton",
      "chaptersButton",
      "captionsButton",
      "shareButton",
      "transcriptButton",
      {
        "name": "bloombergChromeCastButton",
        "appId": "18168741",
        "metadata": {
          "title": "Live TV - Bloomberg",
          "subtitle": "Bloomberg delivers business and markets news, data, analysis, and video to the world, featuring stories from Businessweek and Bloomberg News."
        }
      },
      {
        "name": "theaterMode",
        "children": [
          "theaterModeButton"
        ]
      },
      "fullscreenToggle"
    ]
  },
  "AudioBarsComponent": false,
  "AdControlsComponent": {
    "children": [
      "adBufferingSpinner",
      "adPlayButton",
      "adTagContainer",
      "adControlBar",
      "adTimeRemaining"
    ]
  },
  "DaiAdControlsComponent": {
    "children": [
      "adLearnMore",
      "adTimeRemaining"
    ]
  },
  "CompanionAdComponent": {},
  "PlaybackOutro": {
    "message": "Play Again"
  },
  "TitleBar": {},
  "ContentOverlay": {},
  "ShareOverlay": {},
  "MutedOverlayComponent": {},
  "FoundationOverlayComponent": {},
  "FenceComponent": {},
  "NonInteractiveProgressBarComponent": {},
  "PlayPauseOverlayComponent": {},
  "CustomBufferingComponent": {},
  "plugins": {
    "ActivityOverridePlugin": {},
    "ClosedCaptionsPlugin": {},
    "GoogleAdsPlugin": {},
    "ParselyPlugin": {},
    "PersistListeners": {},
    "PlaybackOutroPlugin": {},
    "PosterPlugin": {},
    "RecoverHlsError": {},
    "ShareControl": {},
    "SmoothScrubbingPlugin": {},
    "TitleBarPlugin": {},
    "ContentOverlayPlugin": {},
    "GoogleTagManagerPlugin": {},
    "TritonSidebandMetadataPlugin": {},
    "TritonCompanionAdPlugin": {},
    "ComscoreStreamSensePlugin": {
      "c4": "BBG",
      "c5": "02"
    },
    "StreamWatchdogPlugin": {
      "liveStreamTimeout": 10000,
      "vodStreamTimeout": 8000
    },
    "YouboraIntegration": {},
    "ResizePlayerPlugin": {},
    "AutoplayBrowsersPlugin": {},
    "VideoMidrollPlugin": {},
    "VideoWatchedTimeUpdatePlugin": {},
    "InitialOverlayPlugin": {},
    "FencePlugin": {},
    "RegUIPopUpPlugin": {},
    "ChromeCastPlugin": {},
    "AudioBarsPlugin": {},
    "DaiPlugin": {},
    "NonInteractiveProgressBarPlugin": {},
    "CustomBufferingPlugin": {},
    "ClosedCaptionsApiPlugin": {},
    "PlayPauseOverlayPlugin": {},
    "TranscriptPlugin": {},
    "ViewabilityPlugin": {},
    "ViewableAdImpressionPlugin": {},
    "TheaterModePlugin": {},
    "PlayerToutPlugin": {},
    "FullscreenAccessibilityPlugin": {}
  }
}
